import api from 'ApiConfig';

const accountantService = {
  createAccountant: async (accountantData) => {
    return api.post('/admin/create-accountant', accountantData);
  },

  getAllAccountant: async (userId, selectedBranch) => {
    return api.post('/admin/get-all-accountant', { userId, selectedBranch });
  },

  updateAccountant: async (payload) => {
    const {
      name: accountantName,
      email: accountantEmail,
      password: accountantPassword,
      _id: accountantId,
    } = payload;
    const updatedPayload = {
      accountantName,
      accountantEmail,
      accountantPassword,
      accountantId,
    };
    return api.post('/admin/update-accountant', updatedPayload);
  },
};
export default accountantService;
